'use client';

import { useRouter } from '@bprogress/next/app';
import { useSelector } from '@xstate/store/react';

import {
  cartActions,
  selectCountProductInCart,
  storeProduct
} from '@/fo/store/product';
import { Grouped, GroupedProduct } from '@/fo/ui/product/section/care-programs';

export interface FeatureProductTileGroupedProps {
  data: GroupedProduct;
}

export function FeatureProductTileGrouped({
  data
}: FeatureProductTileGroupedProps) {
  const router = useRouter();

  const cartCount = useSelector(
    storeProduct,
    selectCountProductInCart(String(data.id))
  );

  const isInCart = cartCount > 0;

  const onCartClick = () => {
    if (isInCart) {
      router.push('/cart');
    } else {
      if (data?.items?.length) {
        cartActions.addProductsToCart(
          data?.items.map((item) => ({
            sku: item.sku,
            quantity: 1,
            product: item
          }))
        );
      }
    }
  };

  return (
    <Grouped
      product={data}
      onAddToCart={onCartClick}
      isInCart={isInCart}
    />
  );
}
